import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/add_card_icon.svg'
import _imports_1 from '../assets/images/linkard_manager_icon.svg'
import _imports_2 from '../assets/images/page_turning_left.svg'
import _imports_3 from '../assets/images/page_turning_right.svg'
import _imports_4 from '../assets/images/circle_add_icon_black.svg'


const _withScopeId = n => (_pushScopeId("data-v-853585a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = { class: "ent-content-wrapper" }
const _hoisted_3 = { class: "left_content_bg" }
const _hoisted_4 = { class: "top_content" }
const _hoisted_5 = { class: "left_content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "enterprise_title" }, "我的联卡", -1))
const _hoisted_7 = { class: "card_number_tips" }
const _hoisted_8 = { class: "top_right_bg" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已过期卡片", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "creat_tips_text" }, "新建联卡", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "card_list_bg" }
const _hoisted_14 = { class: "card-list" }
const _hoisted_15 = {
  key: 0,
  class: "controller_manager_bg"
}
const _hoisted_16 = { class: "controller_manager_info_bg" }
const _hoisted_17 = { class: "manager_name" }
const _hoisted_18 = { class: "manager_phone" }
const _hoisted_19 = ["onClick", "onMouseover", "onMouseleave"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "manage_icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 2,
  class: "dialogue_limit_alarm"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "对话额度不足100次", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "linkcard_list_bottom_view" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_27 = { class: "page_number" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_29 = { class: "right_content_bg" }
const _hoisted_30 = { class: "free_top_content" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "free_experience_title_tips" }, "免费体验联卡", -1))
const _hoisted_32 = { class: "free_experience_count" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "creat_tips_text" }, "新建联卡", -1))
const _hoisted_35 = { class: "residue_opportunity" }
const _hoisted_36 = {
  key: 0,
  class: "dialogue_limit_alarm"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "对话额度不足100次", -1))
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkardInfoItem = _resolveComponent("LinkardInfoItem")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_AuthorityTransferView = _resolveComponent("AuthorityTransferView")!
  const _component_ExpireCardListView = _resolveComponent("ExpireCardListView")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, "已用" + _toDisplayString(_ctx.entLinkardNum) + "张/共" + _toDisplayString(_ctx.entLinkardTotal) + "张", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: _normalizeClass(['right_expire_card_button', _ctx.expireEntLinkardTotal <= 0 ? 'right_expire_card_button_disable' : '']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expireCardButtonClick && _ctx.expireCardButtonClick(...args)))
            }, [
              _hoisted_9,
              _createElementVNode("span", null, "共" + _toDisplayString(_ctx.expireEntLinkardTotal) + "张", 1)
            ], 2),
            _createElementVNode("button", {
              class: "add_card_button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addLinkardButtonClick(1)))
            }, _hoisted_12)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempEntCardList, (linkInfo, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_LinkardInfoItem, {
                  linkardInfo: linkInfo,
                  onClick: ($event: any) => (_ctx.linkardItemClick(1, linkInfo))
                }, {
                  default: _withCtx(() => [
                    (_ctx.currentHoverLinkard == linkInfo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(linkInfo.adminName), 1),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(linkInfo.userPhone ? linkInfo.userPhone :
                            ''), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.userLevel == 4 && _ctx.isEnterpriseAdmin)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "manage_card_button",
                          onClick: _withModifiers(($event: any) => (_ctx.manageCardButtonClick(linkInfo)), ["stop"]),
                          onMouseover: ($event: any) => (_ctx.manageCardButtonMouseOver(linkInfo)),
                          onMouseleave: ($event: any) => (_ctx.manageCardButtonMouseLeave(linkInfo))
                        }, [
                          _hoisted_20,
                          (_ctx.currentHoverLinkard == linkInfo)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "转移"))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_19))
                      : _createCommentVNode("", true),
                    (linkInfo.remainingCnt < 100)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["linkardInfo", "onClick"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_button, {
            disabled: _ctx.currentCardListPage <= 0,
            class: "page_button",
            onClick: _ctx.pageLeft
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.currentCardListPage + 1), 1),
          _createVNode(_component_el_button, {
            disabled: (_ctx.currentCardListPage + 1) * 4 >= _ctx.linkardList.length,
            class: "page_button",
            onClick: _ctx.pageRight
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("span", _hoisted_32, "已用" + _toDisplayString(_ctx.freeExperienceNum) + "张/共" + _toDisplayString(_ctx.freeExperienceTotal) + "张", 1)
        ]),
        (_ctx.freeExperienceTotal - _ctx.freeExperienceNum > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "add_button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addLinkardButtonClick(0)))
            }, [
              _hoisted_33,
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, "剩余可用" + _toDisplayString(_ctx.freeExperienceTotal - _ctx.freeExperienceNum) + "张", 1)
            ]))
          : (_openBlock(), _createBlock(_component_LinkardInfoItem, {
              key: 1,
              linkardInfo: _ctx.freeExperienceCard,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.linkardItemClick(0, _ctx.freeExperienceCard)))
            }, {
              default: _withCtx(() => [
                (_ctx.freeExperienceCard.remainingCnt < 100)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["linkardInfo"]))
      ])
    ]),
    _withDirectives(_createVNode(_component_AuthorityTransferView, {
      transferLinkardInfo: _ctx.transferLinkardInfo,
      onDismissAuthorityTransferView: _ctx.dismissAuthorityTransferView
    }, null, 8, ["transferLinkardInfo", "onDismissAuthorityTransferView"]), [
      [_vShow, _ctx.showAuthorityTransferView]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showExpireCardListView,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showExpireCardListView) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createVNode(_component_ExpireCardListView, {
          expireCardListItem: _ctx.expireCardListItem,
          isActivatable: _ctx.isActivatable,
          onExpireCardListViewClose: _ctx.expireCardListViewClose
        }, null, 8, ["expireCardListItem", "isActivatable", "onExpireCardListViewClose"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}